/**
 * Service pour les opérations sur les utilisateurs
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const usersService = {
  list: (params = {}) => {
    const queryString = new URLSearchParams(params).toString()
    const url = queryString ? `${endpoints.users.list()}?${queryString}` : endpoints.users.list()
    return api.get(url)
  },

  detail: (id) => api.get(endpoints.users.detail(id)),

  create: (data) => api.post(endpoints.users.create(), data),

  update: (id, data) => api.put(endpoints.users.update(id), data),

  delete: (id) => api.delete(endpoints.users.delete(id)),

  getCommercials: () => api.get(endpoints.users.commercials())
}
